'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeftNav = LeftNav;

var _lodash = require('lodash');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _blocks = require('../../blocks');

var _FooterText = require('./FooterText');

var _FooterText2 = _interopRequireDefault(_FooterText);

var _MenuGroupsList = require('./MenuGroupsList');

var _MenuGroupsList2 = _interopRequireDefault(_MenuGroupsList);

var _menuPropTypes = require('./menuPropTypes');

var _menuPropTypes2 = _interopRequireDefault(_menuPropTypes);

var _withExpandedLeftNav = require('./withExpandedLeftNav');

var _withExpandedLeftNav2 = _interopRequireDefault(_withExpandedLeftNav);

var _withExpandedMenus = require('./withExpandedMenus');

var _withExpandedMenus2 = _interopRequireDefault(_withExpandedMenus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeftNav(_ref) {
  var FooterMessage = _ref.FooterMessage,
      TextRenderer = _ref.TextRenderer,
      expanded = _ref.expanded,
      expandedMenus = _ref.expandedMenus,
      handleExpandLeftNavClick = _ref.handleExpandLeftNavClick,
      handleExpandMenuClick = _ref.handleExpandMenuClick,
      location = _ref.location,
      menuGroups = _ref.menuGroups,
      menuGroupsLoading = _ref.menuGroupsLoading;

  var modifiers = (0, _lodash.compact)([expanded && 'expanded']);

  return _react2.default.createElement(
    _blocks.LeftNav,
    { modifiers: modifiers },
    _react2.default.createElement(
      _blocks.LeftNav.MenuBlock,
      { modifiers: modifiers },
      _react2.default.createElement(_MenuGroupsList2.default, {
        TextRenderer: TextRenderer,
        expanded: expanded,
        expandedMenus: expandedMenus,
        handleExpandMenuClick: handleExpandMenuClick,
        location: location,
        menuGroups: menuGroups,
        menuGroupsLoading: menuGroupsLoading
      })
    ),
    _react2.default.createElement(
      _blocks.LeftNav.Footer,
      { modifiers: modifiers },
      _react2.default.createElement(_FooterText2.default, { expanded: expanded, FooterMessage: FooterMessage }),
      _react2.default.createElement(_blocks.LeftNav.ExpanderButton, {
        modifiers: modifiers,
        name: expanded ? 'angle-double-left' : 'angle-double-right',
        onClick: handleExpandLeftNavClick
      })
    )
  );
}

LeftNav.propTypes = {
  FooterMessage: _propTypes2.default.func,
  TextRenderer: _propTypes2.default.func.isRequired,
  expanded: _propTypes2.default.bool.isRequired,
  expandedMenus: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  handleExpandLeftNavClick: _propTypes2.default.func.isRequired,
  handleExpandMenuClick: _propTypes2.default.func.isRequired,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired
  }).isRequired,
  // eslint-disable-next-line react/no-typos
  menuGroups: _menuPropTypes2.default.menuGroups.isRequired,
  menuGroupsLoading: _propTypes2.default.bool
};

LeftNav.defaultProps = {
  FooterMessage: undefined,
  menuGroupsLoading: false
};

var WrappedLeftNav = (0, _withExpandedLeftNav2.default)((0, _withExpandedMenus2.default)(LeftNav));
WrappedLeftNav.displayName = 'LeftNav';

exports.default = WrappedLeftNav;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/LeftNav/index.js
// module id = 1668
// module chunks = 2